import type { IconProps } from "@/types/IconProps";

export function Help(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12 6.201 22.5 12 22.5V24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12v-1.5c5.799 0 10.5-4.701 10.5-10.5"></path>
      <path d="M11.014 13.38c0-.466.078-.95.337-1.432.256-.477.66-.894 1.219-1.279 1.01-.694 1.517-1.103 1.517-2.017 0-.817-.61-1.233-1.073-1.46V7.19c-.153-.074-.518-.16-1.005-.155-.511.008-.995.121-1.378.437a2.05 2.05 0 0 0-.627.858 1.7 1.7 0 0 0-.093.357l-.006.072a.75.75 0 0 1-1.492-.064v-.091l.002-.02.005-.056q.007-.069.026-.176A3 3 0 0 1 8.6 7.8c.167-.44.484-.997 1.076-1.485.744-.613 1.612-.769 2.313-.779.62-.007 1.244.094 1.683.308h.001c.548.268 1.913 1.06 1.913 2.808 0 1.785-1.217 2.6-2.168 3.254-.42.289-.633.54-.747.752-.111.206-.158.43-.158.722a.75.75 0 0 1-1.5 0M11.766 17.944a1.175 1.175 0 1 0 0-2.35 1.175 1.175 0 0 0 0 2.35"></path>
    </svg>
  );
}
